import reactStringReplace from 'react-string-replace';

import { Text } from '../cdl/Text/Text';

interface PartlyBoldTranslationProps {
    translation: string;
}

export const PartlyBoldTranslation = ({ translation }: PartlyBoldTranslationProps) => {
    return (
        <>
            {reactStringReplace(translation, /\[([^\]]+)]/g, (match, i) => (
                <Text key={i} fontWeight={700}>
                    {match}
                </Text>
            ))}
        </>
    );
};
